var render = function render(){
  var _vm$$auth$user;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('ThemedLoading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true,
      "loader": "bars",
      "opacity": 1,
      "can-cancel": false
    }
  }), _vm.confirmation ? _c('ConfirmationProcessing', {
    attrs: {
      "action": _vm.confirmation.action,
      "id": _vm.confirmation.id
    }
  }) : _vm._e(), !_vm.isLoading ? _c('router-view') : _vm._e(), _c('CookieBanner'), _c('MarketingConsentBanner'), _c('portal-target', {
    attrs: {
      "name": "body"
    }
  }), _c('ToastMessage'), _c('ThemeCustomizerPanel'), _vm.$auth.check() && _vm.isReduxiDomain && (_vm$$auth$user = _vm.$auth.user()) !== null && _vm$$auth$user !== void 0 && _vm$$auth$user.isDemoUser ? _c('button', {
    staticClass: "theme-toggle-btn",
    attrs: {
      "title": "Open Theme Customizer"
    },
    on: {
      "click": function ($event) {
        return _vm.$store.dispatch('themeCustomizer/toggleThemeCustomizer');
      }
    }
  }, [_vm._v(" 🎨 ")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }